import BasicDetails from "./BasicDetails/BasicDetails";
import React from "react";
import LocationDetails from "./LocationDetails/LocationDetails";

const CompanyDetails = () => {
    return (
        <>
        <BasicDetails/>

        <LocationDetails/>
        </>
    );
};
export default CompanyDetails;